import styled, { css } from 'styled-components';
interface IProps {
  active: any;
}

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${props => props.theme.spacing.md};
`;

const Button = styled.button`
  background: none;
  border: none;
  padding: ${props => props.theme.spacing.xs} 0;
  font-weight: ${props => props.theme.typography.weights.medium};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  letter-spacing: 0.4px;
  color: ${props => props.theme.colors.textSecondary};
  border-bottom: 3px solid transparent;
  transition: color 0.2s ease, border-color 0.2s ease;

  &:hover {
    color: ${props => props.theme.colors.textPrimary};
  }
`;

export const Btn = styled(Button)<IProps>`
  ${({ active, theme }) =>
    active &&
    css`
      color: ${theme.colors.textPrimary};
      border-bottom-color: ${theme.colors.secondary};
    `}
`;
